import apiClient from 'utilities/apiClient';

export const notifications = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.notifications}/${url}`, payload, true);
};

export const updateNotification = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.notifications}/${url}`,
    payload,
    true
  );
};
